import {deserializeAs} from 'cerialize';

export class ParametrageLogement {
  @deserializeAs('resultat_dpechauffage')
  resultatDpechauffage: number;
  @deserializeAs('resultat_dpeecs')
  resultatDpeecs: number;
  @deserializeAs('resultat_dperefroidissement')
  resultatDperefroidissement: number;
  @deserializeAs('tantieme')
  tantieme: number;
}
